(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-collection-list-carousel-control]');
    if (!control) return;

    var section = control.closest('.collection-list-carousel');
    var track = section && section.querySelector('.collection-list-carousel__track');
    var carousel = track && window.Flickity && window.Flickity.data(track);
    if (!carousel) return;

    if (control.dataset.collectionListCarouselControl === 'next') {
      carousel.next();
    } else {
      carousel.previous();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-editorial-carousel-control]');
    if (control) {
      var section = control.closest('.editorial-collection-carousel');
      var track = section && section.querySelector('.editorial-collection-carousel__track');
      var carousel = track && window.Flickity && window.Flickity.data(track);
      if (carousel) {
        if (control.dataset.editorialCarouselControl === 'next') carousel.next();
        else carousel.previous();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-with-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-json')) {
    customElements.define('faq-json', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => this.initialize());
      }

      initialize() {
        if (this.dataset.initialized) return;
        const sectionTemplate = this.querySelector('[data-faq-section]');
        const itemTemplate = this.querySelector('[data-faq-item]');
        if (!sectionTemplate || !itemTemplate) return;
        this.dataset.initialized = 'true';

        let entries = [];
        try {
          const data = JSON.parse(this.dataset.json);
          if (Array.isArray(data)) {
            entries = data.filter((entry) => entry && typeof entry.question === 'string' && typeof entry.answer === 'string' && entry.question.trim() && entry.answer.trim());
          }
        } catch {
          entries = [];
        }
        if (!entries.length && this.dataset.hideEmpty === 'true') {
          this.remove();
          return;
        }

        const fragment = sectionTemplate.content.cloneNode(true);
        const section = fragment.querySelector('.faq-with-contact');
        const items = fragment.querySelector('.faq-with-contact__items');
        if (!section || !items) return;
        if (entries.length) {
          const jsonItems = document.createDocumentFragment();
          entries.forEach((entry, index) => {
            const item = itemTemplate.content.querySelector('details').cloneNode(true);
            const itemId = `${section.dataset.sectionId}-json-${index + 1}`;
            const summary = item.querySelector('summary');
            const answer = item.querySelector('.details__content');
            item.id = `faq-item-${itemId}`;
            answer.id = `faq-answer-${itemId}`;
            summary.setAttribute('aria-controls', answer.id);
            item.querySelector('.details__title').textContent = entry.question;
            const paragraph = document.createElement('p');
            paragraph.textContent = entry.answer;
            paragraph.style.whiteSpace = 'pre-line';
            answer.replaceChildren(paragraph);
            jsonItems.append(item);
          });
          if (this.dataset.includeBlocks !== 'true') {
            items.replaceChildren(jsonItems);
          } else if (this.dataset.blocksPosition === 'before') {
            items.append(jsonItems);
          } else {
            items.prepend(jsonItems);
          }
        }
        items.querySelectorAll('details').forEach((item) => { item.open = false; });
        if (this.dataset.openFirst === 'true') {
          const firstItem = items.querySelector('details');
          if (firstItem) firstItem.open = true;
        }
        this.replaceChildren(fragment);
      }
    });
  }
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('faq-json').forEach((section) => section.initialize());
  });
  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest('.faq-with-contact__item');
    if (panel) panel.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-images-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('floating-images-text')) {
    customElements.define('floating-images-text', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.motion !== 'true') return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.update = () => {
          this.dataset.playing = String(this.visible && !document.hidden && !this.reducedMotion.matches);
        };
        document.addEventListener('visibilitychange', this.update, options);
        this.reducedMotion.addEventListener('change', this.update, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.update(); });
        this.observer.observe(this);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lusso-layered-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-lusso-hero]';
    const heroes = new Set();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let animationFrame = null;

    const collectHeroes = (root = document) => {
      if (root.matches && root.matches(selector)) heroes.add(root);
      if (root.querySelectorAll) root.querySelectorAll(selector).forEach((hero) => heroes.add(hero));
    };

    const updateHero = (hero) => {
      if (!hero.isConnected) {
        heroes.delete(hero);
        return;
      }

      if (reducedMotion.matches) {
        hero.style.setProperty('--lusso-hero-logo-shift', '0px');
        return;
      }

      const rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;

      const mainContent = document.getElementById('main-content');
      const contentOffset = mainContent ? Math.max(0, mainContent.getBoundingClientRect().top + window.scrollY) : 0;
      const progress = Math.min(1, Math.max(0, (contentOffset - rect.top) / rect.height));
      const configuredDistance = Number.parseFloat(hero.dataset.logoParallaxDistance) || 0;
      const responsiveDistance = window.innerWidth <= 740 ? configuredDistance * 0.4 : configuredDistance;
      hero.style.setProperty('--lusso-hero-logo-shift', `${(progress * responsiveDistance).toFixed(2)}px`);
    };

    const update = () => {
      animationFrame = null;
      heroes.forEach(updateHero);
    };

    const requestUpdate = () => {
      if (animationFrame === null) animationFrame = window.requestAnimationFrame(update);
    };

    const init = () => {
      collectHeroes();
      requestUpdate();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    reducedMotion.addEventListener('change', requestUpdate);

    document.addEventListener('shopify:section:load', (event) => {
      collectHeroes(event.target);
      requestUpdate();
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.matches && event.target.matches(selector)) heroes.delete(event.target);
      if (event.target.querySelectorAll) {
        event.target.querySelectorAll(selector).forEach((hero) => heroes.delete(hero));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-card-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('media-card-carousel')) {
    customElements.define('media-card-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        if (!this.track) return;
        this.controls = this.querySelector('[data-carousel-controls]');
        this.onClick = event => {
          const control = event.target.closest('[data-carousel-direction]');
          if (control) this.move(control.dataset.carouselDirection === 'next' ? 1 : -1);
        };
        this.onKeydown = event => {
          if (event.target !== this.track) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') {
            this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.endPosition(), behavior: this.scrollBehavior() });
          } else {
            const forward = event.key === (this.isRTL() ? 'ArrowLeft' : 'ArrowRight');
            this.move(forward ? 1 : -1);
          }
        };
        this.onScroll = () => this.updateControls();
        this.onBlockSelect = event => {
          const card = event.target.closest('[data-carousel-card]');
          if (!card || !this.contains(card)) return;
          const cardBounds = card.getBoundingClientRect();
          const trackBounds = this.track.getBoundingClientRect();
          const offset = this.isRTL() ? cardBounds.right - trackBounds.right + 4 : cardBounds.left - trackBounds.left - 4;
          this.track.scrollTo({ left: this.track.scrollLeft + offset, behavior: 'auto' });
        };
        this.addEventListener('click', this.onClick);
        this.track.addEventListener('keydown', this.onKeydown);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
        this.updateControls();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.track?.removeEventListener('keydown', this.onKeydown);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
      }
      isRTL() { return getComputedStyle(this.track).direction === 'rtl'; }
      endPosition() { return (this.track.scrollWidth - this.track.clientWidth) * (this.isRTL() ? -1 : 1); }
      scrollBehavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      move(direction) {
        const card = this.track.querySelector('[data-carousel-card]');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        this.track.scrollBy({ left: step * direction * (this.isRTL() ? -1 : 1), behavior: this.scrollBehavior() });
      }
      updateControls() {
        if (!this.controls) return;
        const overflow = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = overflow <= 2;
        this.controls.querySelector('[data-carousel-direction="previous"]').disabled = position <= 2;
        this.controls.querySelector('[data-carousel-direction="next"]').disabled = position >= overflow - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-text-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('story-media')) {
    customElements.define(
      'story-media',
      class extends HTMLElement {
        connectedCallback() {
          this.cover = this.querySelector('[data-story-play]');
          this.player = this.querySelector('[data-story-player]');
          if (!this.cover || !this.player) return;

          this.player.hidden = true;
          this.cover.hidden = false;
          this.play = () => {
            this.cover.hidden = true;
            this.player.hidden = false;
            const video = this.player.querySelector('video');
            video.focus();
            const playback = video.play();
            if (playback) playback.catch(() => {});
          };
          this.cover.addEventListener('click', this.play);
        }
        disconnectedCallback() {
          if (this.cover) this.cover.removeEventListener('click', this.play);

          const video = this.querySelector('video');
          if (video) video.pause();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-media-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scrolling-media-gallery')) {
    customElements.define('scrolling-media-gallery', class extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-gallery-toggle]');
        this.onToggle = () => this.setPaused(!this.hasAttribute('data-paused'));
        if (this.toggle) this.toggle.addEventListener('click', this.onToggle);
        this.onBlockSelect = event => {
          if (this.contains(event.target)) this.setPaused(true);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.observer = new ResizeObserver(() => this.build());
        this.observer.observe(this);
        this.build();
      }
      disconnectedCallback() {
        this.observer.disconnect();
        if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      setPaused(paused) {
        this.toggleAttribute('data-paused', paused);
        if (!this.toggle) return;
        this.toggle.setAttribute('aria-pressed', String(paused));
        this.querySelector('[data-gallery-pause]').hidden = paused;
        this.querySelector('[data-gallery-play]').hidden = !paused;
      }
      decorativeClone(element) {
        const clone = element.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        [clone, ...clone.querySelectorAll('*')].forEach(node => {
          node.removeAttribute('id');
          node.removeAttribute('data-shopify-editor-block');
          if (node.matches('a, button, input, select, textarea, [tabindex]')) node.setAttribute('tabindex', '-1');
        });
        return clone;
      }
      build() {
        if (!this.clientWidth) return;
        this.removeAttribute('data-ready');
        this.querySelectorAll('.scrolling-media-gallery__row').forEach(row => {
          const track = row.querySelector('.scrolling-media-gallery__track');
          const source = row.querySelector('[data-gallery-source]');
          track.querySelectorAll('[data-gallery-clone]').forEach(node => node.remove());
          source.querySelectorAll('[data-gallery-repeat]').forEach(node => node.remove());
          const items = Array.from(source.children);
          if (!items.length) return;
          const itemWidth = items[0].getBoundingClientRect().width;
          if (!itemWidth) return;
          const minimumWidth = row.clientWidth;
          while (source.getBoundingClientRect().width < minimumWidth) {
            items.forEach(item => {
              const repeat = this.decorativeClone(item);
              repeat.setAttribute('data-gallery-repeat', '');
              source.append(repeat);
            });
          }
          const copy = this.decorativeClone(source);
          copy.removeAttribute('data-gallery-source');
          copy.setAttribute('data-gallery-clone', '');
          track.append(copy);
        });
        this.setAttribute('data-ready', '');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
